<template>
  <div>
    <open-fund-header show-shopping-cart/>
    <div class="r-text-headline-paragraph">
      <div>החיסכון שנפתח יחד הוא </div>
      <div>
        <span class="r-text-bold">׳קופת גמל להשקעה׳</span>
        <span>, יעלי מסבירה מה זה אומר:</span>
      </div>
    </div>
    <div class="r-stretch">
      <video-player
        video-url="https://video.wixstatic.com/video/dcff78_00f290ce695249e68f01ef332c6784ea/720p/mp4/file.mp4"
        controls
        poster="/kgl-frame.png"
        @video-played="videoPlayed" />
    </div>
    <default-button label="הבנתי! אפשר להמשיך" @click="nextStep" class="next-button" />
    <disclaimer />

  </div>

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import TrackedPage from '@/mixins/TrackedPage';
import GeneralErrorHandling from '@/mixins/GeneralErrorHandling';
import DefaultButton from '@/components/styled/DefaultButton';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import { SIGNUP_FIRST_PAGE } from '@/router/consts';
import Disclaimer from '@/components/meitav-dash/Disclaimer';

export default {
  name: 'Kgl',
  components: {
    Disclaimer,
    OpenFundHeader,
    DefaultButton,
    VideoPlayer: BaseUI.VideoPlayer,
  },
  mixins: [TrackedPage, GeneralErrorHandling],
  computed: {
    ...mapGetters('session', ['authenticated']),
  },
  methods: {
    ...mapActions('signup', ['signupMember']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setEmail', 'setEnableMarketingEmails']),
    async nextStep() {
      if (this.authenticated) {
        try {
          await this.signupMember();
          await this.$router.push({ path: '/meitav/open-fund' });
        } catch (err) {
          this.logErrorAndShowDialog(err);
        }
      } else {
        this.$router.push(SIGNUP_FIRST_PAGE);
      }
    },
    videoPlayed() {
      Segment.trackUserInteraction('Saving_KGLVideoPlayClicked');
    },
  },

};
</script>

<style scoped lang="scss">

.next-button {
  margin: 36px 0 24px 0;
}

.what-is-kgl-button {
  margin-bottom: 36px;
}
</style>
